import PillList from './PillList'

export default PillList
